import "@fortawesome/fontawesome-free/css/all.min.css";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import FullPageLoading from "./components/library/FullPageLoading/FullPageLoading";
import configureStore, { fetchConfig } from "./config";
import {
  fetchParticipantStudyStatus,
  initializeSession,
} from "./modules/login";
import * as serviceWorker from "./serviceWorker";
import App from "./App";
import { sendNotification } from "./components/ToastManager/ToastManager";
import { ToastType } from "./components/ToastManager/constants";
import { setupInterceptors } from "./modules/http";
import "./i18n";
import { refreshAppLanguage } from "./i18n/helpers";

const { store } = configureStore();
setupInterceptors(store);
class Launcher extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      configError: null,
    };
  }

  async componentDidMount() {
    try {
      await fetchConfig();
      refreshAppLanguage();

      store
        .dispatch(initializeSession())
        .then(() => {
          store.dispatch(fetchParticipantStudyStatus()).finally(() => {
            this.setState({ loading: false });
          });
        })
        .catch((e) => {
          this.setState({ loading: false });
          sendNotification(e, ToastType.ERROR);
        });
    } catch (error) {
      this.setState({ loading: false, configError: error.message });
    }
  }

  render() {
    if (this.state.configError) {
      return (
        <div style={{ padding: "20px" }}>
          <h4>Application failed to load</h4>
          <p>{this.state.configError}</p>
          <h4>Try later...</h4>
        </div>
      );
    }

    return this.state.loading && this.state.token === undefined ? (
      <FullPageLoading />
    ) : (
      <Provider store={store}>
        <App />
      </Provider>
    );
  }
}

ReactDOM.render(<Launcher />, document.getElementById("root"));
serviceWorker.unregister();
